import { cn } from "@/lib/utils";
import React from "react";

interface ProgressBarProps {
  barColor: string;
  value: number;
  className?: string;
}

const ProgressBar = ({
  barColor = "#26C2DD",
  className,
  value = 25,
}: ProgressBarProps) => {
  return (
    <div
      style={{
        background:
          "linear-gradient(90deg, rgba(51, 135, 169, 0.25) 0%, rgba(86, 189, 231, 0.25) 100%)",
      }}
      className={cn(
        "relative flex h-[15px] w-full flex-col rounded-full border border-white/10",
        className
      )}
      data-testid="progress-bar-container"
    >
      <div
        role="progressbar"
        style={{
          background: barColor,
          width: `${value === 0 ? "0px" : `calc(${value}% + 2px)`}`,
        }}
        className="absolute -left-px -top-px h-[15px] rounded-full shadow-[inset_0px_4px_4px_0px_#00000040]"
      ></div>
    </div>
  );
};

export default ProgressBar;
